// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-alert[data-v-8db501ca] .v-alert__content{width:100%!important}.v-alert--outlined[data-v-8db501ca]{background:#fff!important;border:thin solid!important}", ""]);
// Exports
module.exports = exports;
